/**
 * Normalizes the server URL to ensure it has a protocol.
 * If the URL already includes a protocol (http:// or https://), returns it as-is.
 * If no protocol is present, defaults to https://
 *
 * @param {string} serverUrl - The server URL from environment variable
 * @returns {string} The normalized URL with protocol
 */
export const normalizeServerUrl = (serverUrl) => {
  if (!serverUrl) {
    return "";
  }

  // Check if the URL already has a protocol
  if (serverUrl.startsWith("http://") || serverUrl.startsWith("https://")) {
    return serverUrl;
  }

  // Default to https:// if no protocol is specified
  return `https://${serverUrl}`;
};
